import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="#68B76C" />
      <path
        d="M11.3495 6.95711C11.74 6.56658 11.74 5.93342 11.3495 5.54289C10.959 5.15237 10.3258 5.15237 9.93527 5.54289L7.14244 8.33573L6.05679 7.33579C5.66627 6.94526 5.0331 6.94526 4.64258 7.33579C4.25205 7.72631 4.25205 8.35948 4.64258 8.75L6.43533 10.457C6.82586 10.8476 7.45902 10.8476 7.84955 10.457L11.3495 6.95711Z"
        fill="white"
      />
    </svg>
  );
};

export default Svg;
